var React = require('react');

function Agenda (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M47,1.3H17c-2.6,0-4.8,2.1-4.8,4.8v45.5c0,2.5,1.9,4.5,4.3,4.7v3.7c0,0.9,1.1,1.4,1.8,0.8l0.1-0.1c0.4-0.3,1-0.3,1.4,0\tl0.1,0.1c0.7,0.6,1.8,0.1,1.8-0.8v-3.7H47c2.6,0,4.8-2.1,4.8-4.8V6C51.8,3.4,49.6,1.3,47,1.3z M40.4,20.2h7.9v14.5h-7.9V20.2z M36.9,34.7H15.7V20.2h21.2V34.7z M48.3,6v10.7h-7.9V4.8H47C47.7,4.8,48.3,5.3,48.3,6z M17,4.8h19.9v11.9H15.7V6\tC15.7,5.3,16.3,4.8,17,4.8z M15.7,51.5V38.2h21.2v14.5H17C16.3,52.7,15.7,52.2,15.7,51.5z M47,52.7h-6.6V38.2h7.9v13.3\tC48.3,52.2,47.7,52.7,47,52.7z"}));
}

Agenda.defaultProps = {"version":"1.1","viewBox":"0 0 64 64","x":"0","y":"0","xmlSpace":"preserve"};

module.exports = Agenda;

Agenda.default = Agenda;
